export enum NewContactCondition {
  SOURCE = "source",
}
